export const COMPLAINTS = Object.freeze({
    COMPLAINT_TYPE: {
        INTERNAL: 1,
        EXTERNAL: 2
    },
    COMPLAINT_STATUS: {
        NEW: 1,
        IN_PROGRESS: 2,
        WAIT_FOR_RETURN: 3,
        ACCEPTED: 4,
        ACCEPTED_AFTER_DEADLINE: 6,
        ACCEPTED_BY_DMT: 8,
        DRAFT: 15
    },
    DEPARTMENTS: {
        DKJ: 'DKJ'
    },
    NUMBERS_SEARCH_LIMIT: 20
})

export const EXTERNAL_COMPLAINT_CONFIRMABLE_STATUS_IDS = Object.freeze([
    COMPLAINTS.COMPLAINT_STATUS.ACCEPTED,
    COMPLAINTS.COMPLAINT_STATUS.ACCEPTED_BY_DMT
])

export const PROCEEDING_TYPES = Object.freeze({
    NO_REPRINT: 10,
    ADJUSTMENT: 20,
    REPRINT: 30
})

export const ACTION_TYPES = Object.freeze({
    CREATE: 'create',
    EDIT: 'edit'
})

export const INTERNAL_COMPLAINT_PRODUCT_DESCRIPTION_MAX_LENGTH = 1000
export const COMPLAINT_COST_MAX = 999_999.99

export const STATUSES = Object.freeze({
    NEW: 1,
    IN_PROGRESS: 2,
    ACCEPTED: 4,
    REJECTED: 5
})

export const INTERNAL_COMPLAINT_TABS = Object.freeze({
    DETAILS: 0,
    ATTACHMENTS: 1,
    CAUSES: 2,
    RECOMMENDATIONS: 3,
    EXECUTION: 4
})

export const STOP_CARD_STATUS = Object.freeze({
    CLOSED: 20
})

export const STOP_CARD_WAY_OF_CLOSING = Object.freeze({
    QUALITATIVE_NOTE: 20,
    INTERNAL_COMPLAINT: 30
})
